
import {Injectable} from '@angular/core';
import {IWorkflowCollectionState} from '../../features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
@Injectable()
export class WorkflowService {
  constructor(private store: Store<IWorkflowCollectionState>) {
  }
}
